/**
 * Cookie de ruteo de impresora (browser → WebSocket).
 * Por tenant: printerNumber_<tenant>. Migra el legacy printerNumber si existe.
 */

import { erpCookies } from '../../utils/erpCookies.js';

const LEGACY_COOKIE = 'printerNumber';

function getCookie(name) {
  const pattern = `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`;
  const match = document.cookie.match(new RegExp(pattern));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/;`;
}

function clearCookie(name) {
  document.cookie = `${name}=; path=/; max-age=0`;
}

/**
 * Tenant de la sesión. Desde el 2026-09-08 la cookie es `lutenteERP_tenant`
 * (ver utils/erpCookies.js): leer `document.cookie` a mano buscando `tenant`
 * devolvía null y terminaba en 'unknown', y con eso el server no encontraba
 * ningún agente. Devuelve null si no hay sesión: mejor sin filtro que uno imposible.
 */
export function getTenantKey() {
  return erpCookies.get('tenant') || null;
}

export function getPrinterCookieName(tenant = getTenantKey()) {
  return `${LEGACY_COOKIE}_${tenant || 'unknown'}`;
}

export function getPrinterNumberCookie(tenant = getTenantKey()) {
  const scoped = getCookie(getPrinterCookieName(tenant));
  if (scoped) return scoped;

  // Migración one-shot: del cookie global viejo (printerNumber) o del que quedó
  // guardado como printerNumber_unknown mientras el tenant no se resolvía.
  const legacyName = [LEGACY_COOKIE, getPrinterCookieName('unknown')]
    .filter((name) => name !== getPrinterCookieName(tenant))
    .find((name) => getCookie(name));
  if (legacyName) {
    const legacy = getCookie(legacyName);
    setCookie(getPrinterCookieName(tenant), legacy);
    clearCookie(legacyName);
    return legacy;
  }
  return null;
}

export function setPrinterNumberCookie(value, tenant = getTenantKey()) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return;
  setCookie(getPrinterCookieName(tenant), trimmed);
  clearCookie(LEGACY_COOKIE);
}

export function clearPrinterNumberCookie(tenant = getTenantKey()) {
  clearCookie(getPrinterCookieName(tenant));
  clearCookie(LEGACY_COOKIE);
}
